import { getBrandInCaps } from '@tcp/core/src/utils';
import CONSTANT from '../../EnjoyingAppPopup/container/EnjoyingAppModal.constants';

export const getPartNumber = (addedToBagData) => {
  let partNum;
  if (Array.isArray(addedToBagData)) {
    [partNum] = addedToBagData.map((item) => item && item.skuInfo && item.skuInfo.productId);
  } else {
    partNum = addedToBagData && addedToBagData.skuInfo && addedToBagData.skuInfo.productId;
  }
  return partNum;
};

export const getVariantID = (addedToBagData) => {
  let variantId;
  if (Array.isArray(addedToBagData)) {
    [variantId] = addedToBagData.map((item) => item && item.skuInfo && item.skuInfo.variantId);
  } else {
    variantId = addedToBagData && addedToBagData.skuInfo && addedToBagData.skuInfo.variantId;
  }
  return variantId;
};

export const getOfferPrice = (addedToBagData) => {
  let offerPrice;
  if (Array.isArray(addedToBagData)) {
    offerPrice += addedToBagData.map(
      (item) => item && item.skuInfo && parseFloat(item.skuInfo.offerPrice)
    );
  } else {
    offerPrice = addedToBagData && addedToBagData.skuInfo && addedToBagData.skuInfo.offerPrice;
  }
  return offerPrice;
};

export const getShowPickupBanner = (showBOPISPickupInstead, pickupType) =>
  showBOPISPickupInstead && !pickupType;

export const isAddedFromSBP = (addedToBagData) => addedToBagData && addedToBagData.addedFromSBP;

export const getMultiPackStyleType = (styleType) => {
  if (styleType === '0001') return 'Single';
  if (styleType === '0002') return 'Multipack';
  if (styleType === '0003') return 'Set';
  if (styleType === '0005') return 'Virtual Multipack';
  if (styleType === '0006') return 'Virtual Set';
  return '';
};

export const constructAnalyticsName = (dismissedCount, getPageType) => {
  const getBrandName = getBrandInCaps();
  const nameShown1Modal = `${getBrandName}_${getPageType}${CONSTANT.ANALYTICS_RATING_POP_UP_SHOWN1}`;
  const nameShown2Modal = `${getBrandName}_${getPageType}${CONSTANT.ANALYTICS_RATING_POP_UP_SHOWN2}`;
  return dismissedCount === 1 ? nameShown2Modal : nameShown1Modal;
};

export const constructFeedBackModalAnalyticsName = () => {
  const getBrandName = getBrandInCaps();
  return `${getBrandName}${CONSTANT.MODAL_OH_NO}`;
};

export const rateUsModal = (modalCount, isPositiveButton, isNegativeButton, pageType) => {
  const modalName = constructAnalyticsName(modalCount, pageType);
  if (isPositiveButton) {
    return `${modalName}${CONSTANT.CLICK_YES}`;
  }
  if (isNegativeButton) {
    return `${modalName}${CONSTANT.CLICK_NOT_REALLY}`;
  }
  return null;
};
